import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const exchangeRateSchemaLiteral = {
  title: 'exchange_rate',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    since: { type: 'string', pattern: '^[0-9]{4}-[0-9]{2}-[0-9]{2}$', maxLength: 10 },
    until: { type: 'string', pattern: '^[0-9]{4}-[0-9]{2}-[0-9]{2}$', maxLength: 10 },
    eur: { type: 'number' },
    usd: { type: 'number' },
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'since', 'until', 'updated_at', 'is_deleted'],
  indexes: ['is_deleted', 'since', 'until', 'updated_at'],
} as const;

const schemaTyped = toTypedRxJsonSchema(exchangeRateSchemaLiteral);
export type ExchangeRateDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const exchangeRateSchema: RxJsonSchema<ExchangeRateDocType> = exchangeRateSchemaLiteral;
